import i18next, { i18n as i18nInstance } from 'i18next';
import { initReactI18next, DefaultResources } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import { DEFAULT_LOCALE, translationResources } from './resources';

const createI18n = (lang: string): i18nInstance => {
  const i18n = i18next.createInstance().use(initReactI18next);
  i18n.use(detector).init({
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [],
    },
    resources: translationResources,
    fallbackLng: {
      default: [lang],
    },
    react: {
      useSuspense: false,
    },
  });
  return i18n;
};

export const i18n = createI18n(DEFAULT_LOCALE);

export type LocaleKey = keyof DefaultResources['grantsNominationForm'];
